import React, { useState, useEffect } from "react";
import { getUserDetailsByIdForOvrview } from "../../../AdminActionCreator.component";
import Loader from '../../../../../presentationals/Loader/Loader.component'

const yellow = "#fde9a9";
const peach = "#fce4d6";
const border = "1px solid #ddd";
const cell = (bg) => ({
    border,
    padding: "6px 10px",
    verticalAlign: "middle",
    background: bg || "white",
});

const spacer = {
    ...cell(),
    width: "12px",
    padding: "0",
};


export default function OverviewMain(allDetail, userDetail) {
    const [selectedDoc, setSelectedDoc] = useState("")
    const [loader, setLoader] = useState(false)
    const [apiData, setapiData] = useState({})

    useEffect(() => {
        getUserDetailsByIdForOvrviewFn()
    }, [])

    const getUserDetailsByIdForOvrviewFn = () => {
        setLoader(true)
        getUserDetailsByIdForOvrview(allDetail?.allDetail?.userId, allDetail?.allDetail?.loanId, callback => {
            setapiData(callback?.data || {})
            setLoader(false)
        })
    }



    const mask = (val, start = 4, end = 4) => {
        if (!val) return "-";
        const s = String(val);
        if (s.length <= start + end) return s;
        return s.slice(0, start) + "******" + s.slice(-end);
    };

    const firstOrDash = (arr) => (Array.isArray(arr) && arr.length ? arr[0] : "-");

    return (
        <div className="container-fluid" style={{ marginTop: '30px' }}>
            {
                loader ? <Loader /> : ""
            }
            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="2" style={cell(yellow)} className="text-center fs-5">
                                Case Status
                            </th>
                        </tr>

                        <tr>
                            <th style={{ ...cell(peach), width: '50%' }}>Case Approval Stage (Tab Open Req)</th>
                            <th style={spacer}></th>

                        </tr>

                        <tr>
                            <td style={cell()}>Loan Eligibility Check - </td>
                            <td style={spacer}>{apiData?.loanEligibilityCheck}</td>

                        </tr>

                        <tr>
                            <td style={cell()}>TVR Status - </td>
                            <td style={spacer}>{apiData?.tvrStatus}</td>

                        </tr>

                        {/* <tr>
                            <td style={cell()}>FI Status - Not Require</td>
                            <td style={spacer}>-</td>

                        </tr> */}

                        <tr>
                            <td style={cell()}>D.O Status -</td>
                            <td style={spacer}>{apiData?.doStatus}</td>

                        </tr>

                        <tr>
                            <td style={cell()}>Disbursement Clear Status - </td>
                            <td style={spacer}>{apiData.disbursementClearStatus || "-"}</td>

                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="7" style={cell(yellow)} className="text-center fs-5">
                                Login to Approval Dashboard
                            </th>
                        </tr>

                        <tr>
                            <th style={cell(peach)}>Login By Dealer</th>
                            <th style={spacer}></th>
                            <th style={cell(peach)}>Login Product</th>
                            <th style={spacer}></th>
                            <th style={cell(peach)}>Loan Apply</th>
                            <th style={spacer}></th>
                            <th style={cell(peach)}>Loan Duplicacy</th>
                        </tr>

                        <tr>
                            <td style={cell()}>Login Date-</td>
                            <td style={spacer}>{apiData.loginDate || "-"}</td>
                            <td style={cell()}>Product-</td>
                            <td style={spacer}>{apiData.product || "-"}</td>
                            <td style={cell()}>Loan Amt-</td>
                            <td style={spacer}>{apiData.loanAmount || "-"}</td>
                            <td style={cell()}>
                                {apiData.mobileDuplicate ? "Mobile Duplicate" : "Mobile NEW"}
                            </td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login Time-</td>
                            <td style={spacer}>-</td>
                            <td style={cell()}>Product Type-</td>
                            <td style={spacer}>{apiData.productType || "-"}</td>
                            <td style={cell()}>Loan Tenure-</td>
                            <td style={spacer}>{apiData.loanTenure || "-"}</td>
                            <td style={cell()}>
                                {apiData.aadhaarDuplicate ? "Aadhaar Duplicate" : "Aadhaar NEW"}
                            </td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login Dealer Mobile-</td>
                            <td style={spacer}>{apiData.loginDealerMobile || "-"}</td>
                            <td style={cell()}>Product Serial No-</td>
                            <td style={spacer}>{apiData.productSerialNo || "-"}</td>
                            <td style={cell()}>EMI Amt-</td>
                            <td style={spacer}>{apiData.emiAmount ?? "-"}</td>
                            <td style={cell()}></td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login Dealer Name-</td>
                            <td style={spacer}>{apiData.loginDealerName || "-"}</td>
                            <td style={cell()}>Vehicle Registration No-</td>
                            <td style={spacer}>{apiData.vehicleRegNo || "-"}</td>
                            <td style={cell()}>Down Payment-</td>
                            <td style={spacer}>{apiData.downPayment || "-"}</td>
                            <td style={cell()}></td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login Dealer Code-</td>
                            <td style={spacer}>{apiData.loginDealerCode || "-"}</td>
                            <td style={cell()}></td>
                            <td style={spacer}></td>
                            <td style={cell()}>File Charge-</td>
                            <td style={spacer}>{apiData.fileCharge ?? "-"}</td>
                            <td style={cell()}></td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login User State-</td>
                            <td style={spacer}>{firstOrDash(apiData.loginUserState)}</td>
                            <td style={cell()}></td>
                            <td style={spacer}></td>
                            <td style={cell()}>Other Charge-</td>
                            <td style={spacer}>-</td>
                            <td style={cell()}></td>
                        </tr>

                        <tr>
                            <td style={cell()}>Login User District-</td>
                            <td style={spacer}>{firstOrDash(apiData.loginUserDistrict)}</td>
                            <td style={cell()}></td>
                            <td style={spacer}></td>
                            <td style={cell()}></td>
                            <td style={spacer}></td>
                            <td style={cell()}></td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="6" style={cell(yellow)} className="text-center fs-5">
                                Customer / Co-Borrower / Guarantor Details
                            </th>
                        </tr>

                        <tr>
                            <th style={cell(peach)}>Customer Details</th>
                            <th style={spacer}></th>
                            <th style={cell(peach)}>Co-Borrower Details</th>
                            <th style={spacer}></th>
                            <th style={cell(peach)}>Guarantor Details</th>
                            <th style={spacer}></th>
                        </tr>

                       
                        <tr>
                            <td style={cell()}>Cust Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.customerName}</td>
                            <td style={cell()}>C0B Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobName}</td>
                            <td style={cell()}>Guar Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurName}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Gender-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gender}</td>
                            <td style={cell()}>Gender-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobGender}</td>
                            <td style={cell()}>Gender-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurGender}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Father Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.fatherName}</td>
                            <td style={cell()}>Father Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobfatherName}</td>
                            <td style={cell()}>Father Name-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurfatherName}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>D.O.B-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.dateOfBirth}</td>
                            <td style={cell()}>D.O.B-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobdateOfBirth}</td>
                            <td style={cell()}>D.O.B-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurdateOfBirth}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Age-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.age}</td>
                            <td style={cell()}>Age-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobage}</td>
                            <td style={cell()}>Age-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurage}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Mobile No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.customerMobile}</td>
                            <td style={cell()}>Mobile No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobMobile}</td>
                            <td style={cell()}>Mobile No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurMobile}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Aadhaar No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.aadharNo}</td>
                            <td style={cell()}>Relation with Borrower-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobrelationWithBorrower}</td>
                            <td style={cell()}>Relation with Borrower-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurrelationWithBorrower}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Adhaar Verified-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.aadharAddress ? "Yes" : "-"}</td>
                            <td style={cell()}>Aadhaar No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobaadharNo}</td>
                            <td style={cell()}>Aadhaar No-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gauraadharNo}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Address Type- OWN/Rent</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.addressType}</td>
                            <td style={cell()}>Address Type- OWN/Rent</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobaddressType}</td>
                            <td style={cell()}>Address Type- OWN/Rent</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gauraddressType}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Adhaar Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.aadharAddress}</td>
                            <td style={cell()}>Adhaar Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobaadharAddress}</td>
                            <td style={cell()}>Adhaar Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gauraadharAddress}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Current Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.currentAddress}</td>
                            <td style={cell()}>Current Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.cobcurrentAddress}</td>
                            <td style={cell()}>Current Address-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>{apiData.gaurcurrentAddress}</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Landmark-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                            <td style={cell()}>Landmark-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                            <td style={cell()}>Landmark-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                        </tr>
                        <tr>
                            <td style={cell()}>Police Station/Post Office-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                            <td style={cell()}>Police Station/Post Office-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                            <td style={cell()}>Police Station/Post Office-</td>
                            <td style={{ ...spacer, wordWrap: 'break-word', whiteSpace: 'wrap', width: 'calc(100% /6)' }}>-</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="2" style={cell(yellow)} className="text-center fs-5">
                                Pendancy Remarks
                            </th>
                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Pendancy Remarks - </td>
                            <td style={spacer}>{apiData.pendencyRemark || "-"}</td>

                        </tr>
                        <tr>
                            <th colSpan="2" style={cell(yellow)} className="text-center fs-5">
                                Pendancy Remarks History
                            </th>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="4" style={cell(yellow)} className="text-center fs-5">
                                Disbursment Clear
                            </th>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ ...cell(), width: '50%' }}>Banking By-</td>
                            <td colSpan={2} style={spacer}>{apiData.bankingBy || "-"}</td>

                        </tr>

                        <tr>
                            <th style={{ ...cell(peach), width: 'calc(100%/4)' }}>Case Approval Stage (Tab Open Req)</th>
                            <th style={{ ...spacer, width: 'calc(100%/4)' }}></th>
                            <th style={{ ...cell(peach), width: 'calc(100%/4)' }}>Reference for Disbursment</th>
                            <th style={{ ...spacer, width: 'calc(100%/4)' }}></th>

                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Name as on Bank-</td>
                            <td style={spacer}>{apiData.bankingBy || "-"}</td>
                            <td style={{ ...cell(), width: '50%' }}>Name-</td>
                            <td style={spacer}>{apiData.refrenceName || "-"}</td>


                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Bank Name-</td>
                            <td style={spacer}>{apiData.bankingBy || "-"}</td>
                            <td style={{ ...cell(), width: '50%' }}>Relation-</td>
                            <td style={spacer}>{apiData.refrenceRelation || "-"}</td>

                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Account Number-</td>
                            <td style={spacer}>{apiData.bankingBy || "-"}</td>
                            <td style={{ ...cell(), width: '50%' }}>Mobile Number-</td>
                            <td style={spacer}>{apiData.refrenceNumber || "-"}</td>

                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>IFSC Code-</td>
                            <td style={spacer}>{apiData.bankingBy || "-"}</td>
                            <td style={{ ...cell(), width: '50%' }}>E-Signature Status-</td>
                            <td style={spacer}>{apiData.esignStatus || "-"}</td>

                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Branch-</td>
                            <td style={spacer}>{apiData.bankingBy || "-"}</td>
                            <td style={{ ...cell(), width: '50%' }}>Invoice for Disbursment-</td>
                            <td style={spacer}>{apiData.esignStatus || "-"}</td>

                        </tr>


                    </tbody>
                </table>
            </div>
            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="2" style={cell(yellow)} className="text-center fs-5">
                                Pendancy Remarks
                            </th>
                        </tr>
                        <tr>
                            <td style={{ ...cell(), width: '50%' }}>Pendancy Remarks - </td>
                            <td style={spacer}>{apiData.pendencyRemark || "-"}</td>

                        </tr>
                        <tr>
                            <th colSpan="2" style={cell(yellow)} className="text-center fs-5">
                                Pendancy Remarks History
                            </th>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div style={{ overflowY: 'auto', marginBottom: '15px' }}>
                <table className="table" style={{ margin: '0' }}>
                    <tbody>
                        <tr>
                            <th colSpan="" style={cell(yellow)} className="text-center fs-5">
                                Documents
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mt-3 mb-4">
                <select
                    className="form-control"
                    style={{
                        padding: "6px",
                        width: "260px",
                    }}
                    defaultValue=""
                    value={selectedDoc}
                    onChange={(e) => setSelectedDoc(e.target.value)}
                >
                    <option value="">Select Option</option>
                    {
                        apiData?.adminList && apiData?.adminList?.length > 0 ? apiData?.adminList?.map((val, id) => {
                            return (
                                <option value={val?.documentUrl}>{val?.type}</option>
                            )
                        })
                            : ""}

                </select>
            </div>

            <div className="row" style={{ marginBottom: '20px' }}>
                <div className="col-sm-3 col-xs-12" style={{ marginTop: '20px' }}>
                    <div className="">
                        <div
                            style={{
                                borderRadius: '8px',
                                height: '80px', width: '100%'
                            }}
                        >
                            {
                                selectedDoc?.split("&type=")?.[1] == "img" ?
                                    <img src={selectedDoc} width={"100%"} />
                                    :
                                    <iframe
                                        title="iframe-1"
                                        src={selectedDoc}
                                        style={{

                                        }}
                                    />
                            }


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}